<section class="slot-board" [attr.aria-labelledby]="boardLabelledBy()">
  @if (heading()) {
    <h3 [id]="boardLabelledBy()">{{ heading() | translate }}</h3>
  }
  @if (loading() && !snapshot()) {
    <app-loading [loading]="true"></app-loading>
  } @else if (errorMessage() && !snapshot()) {
    <div class="error-message">{{ errorMessage() | translate }}</div>
  } @else {
    @if (snapshot(); as current) {
      @if (errorMessage()) {
        <div class="error-message">{{ errorMessage() | translate }}</div>
      }
      <dl>
        <div>
          <dt>{{ 'Total size' | translate }}</dt>
          <dd>{{ totalSizeLabel() }}</dd>
        </div>
        <div>
          <dt>{{ 'Objects' | translate }}</dt>
          <dd>{{ objectCount() }}</dd>
        </div>
        <div>
          <dt>{{ 'Buckets' | translate }}</dt>
          <dd>{{ bucketCount() }}</dd>
        </div>
        <div>
          <dt>{{ 'Last write' | translate }}</dt>
          <dd>
            @if (latestWriteAt(); as writeAt) {
              {{ writeAt | date: 'short' }}
            } @else {
              —
            }
          </dd>
        </div>
        @if (showDisk()) {
          <div>
            <dt>{{ 'Disk free' | translate }}</dt>
            <dd>{{ diskAvailableLabel() }}</dd>
          </div>
          <div>
            <dt>{{ 'Disk size' | translate }}</dt>
            <dd>{{ diskTotalLabel() }}</dd>
          </div>
        }
      </dl>
      @if (current.generatedAt) {
        <p class="slot-meta">{{ current.generatedAt | date: 'medium' }}</p>
      }
    }
  }
</section>
